import React from 'react';
import PropTypes from 'prop-types';
import Svg from '../Svg';

const ChatDocument = ({ file }) => (
  <a
    href={file.url_original}
    target="_blank"
    className="chat-list_image-wrapper"
    title={file.filename}
  >
    <div className="chat-list_image-placeholder">
      <Svg icon="icon-document" />
      <div className="chat-list_image-filename">{file.filename}</div>
    </div>
  </a>
);

ChatDocument.propTypes = {
  file: PropTypes.shape({}).isRequired,
};

export default React.memo(ChatDocument);



// WEBPACK FOOTER //
// ./app/javascript/common/components/ChatMessage/ChatDocument.js